var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('svg-icon',{staticClass:"back",attrs:{"icon-class":"back"},on:{"click":_vm.goBack}}),_vm._v(" "+_vm._s(_vm.$t('sign.name'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }